import React from "react";
import "./App.css";
import {MainArea} from "./MainArea";
import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import {EventPage} from "./EventPage";
import {TrialSchedulePage} from "./TrialSchedulePage";

const TrainingRegistrationPage = () => {
  return (
    <div className="App">
      <header className="App-header">
        <MainArea />
      </header>
    </div>
  );
};

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <TrainingRegistrationPage />
        </Route>
        <Route exact path="/app/event/:id">
          <EventPage />
        </Route>
        <Route exact path="/app/trial">
          <TrialSchedulePage />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
